import {useStore} from '@/store';
import {APP_MODULE} from '@/store/state';
import {Commit} from 'vuex';

const MODULE_NAME = 'CHAT_HISTORY';

type ChatHistoryStore = {
  messages: string[];
};

const ChatHistoryGetters = {
  GET: `${MODULE_NAME}/GET`,
};

const ChatHistoryActions = {
  ADD_MESSAGE: `${MODULE_NAME}/ADD_MESSAGE`,
  CLEAR: `${MODULE_NAME}/CLEAR`,
  REMOVE_LAST: `${MODULE_NAME}/REMOVE_LAST`,
};

const ChatHistoryMutations = {
  SET: `${MODULE_NAME}/SET`,
};

type ChatHistoryPayload = {
  messages: string[];
};

const store = useStore();

export const ChatHistoryModule = {
  getMessages: (): string[] => store.getters[`${APP_MODULE}/${ChatHistoryGetters.GET}`],
  addMessage: (newMessage: string) => store.dispatch(`${APP_MODULE}/${ChatHistoryActions.ADD_MESSAGE}`, newMessage),
  removeLastMessage: () => store.dispatch(`${APP_MODULE}/${ChatHistoryActions.REMOVE_LAST}`),
  clearMessages: () => store.dispatch(`${APP_MODULE}/${ChatHistoryActions.CLEAR}`),
  state: {
    messages: [],
  },
  getters: {
    [ChatHistoryGetters.GET]: (state: ChatHistoryStore) => {
      return state.messages || [];
    },
  },
  actions: {
    [ChatHistoryActions.ADD_MESSAGE]: ({commit}: {commit: Commit}, message: string) => {
      commit(ChatHistoryMutations.SET, {messages: [...ChatHistoryModule.getMessages(), message]});
    },
    [ChatHistoryActions.REMOVE_LAST]: ({commit}: {commit: Commit}) => {
      commit(ChatHistoryMutations.SET, {messages: [...ChatHistoryModule.getMessages().slice(0, -1)]});
    },
    [ChatHistoryActions.CLEAR]: ({commit}: {commit: Commit}) => {
      commit(ChatHistoryMutations.SET, {messages: []});
    },
  },
  mutations: {
    [ChatHistoryMutations.SET]: (state: ChatHistoryStore, {messages}: ChatHistoryPayload) => {
      state.messages = [...messages];
    },
  },
};
